import { setStatusTenant } from "@/Api/tenants";
import { Switch } from "@/components/ui/switch";
import { useEffect, useState } from "react";

type SwitchParams = {
    defaultChecked: boolean,
    tenantId: string,
    updateFront: any,
}

export const SwitchActivateTenant = ({defaultChecked, tenantId, updateFront}: SwitchParams) => {
    const [ isDisabled, setIsDisabled ] = useState(false);
    const [ animateError, setAnimateError ] = useState("");

    const handleChecked = async () => {
        setIsDisabled(prev => !prev);
        const { data } = await setStatusTenant(tenantId);
        
        if(Object.keys(data).length === 0) {
            setAnimateError("animate-shake");
            return setIsDisabled(prev => !prev);
        };

        setIsDisabled(prev => !prev);
        updateFront(prev => {
            return {
                ...prev,
                data: prev?.data?.map( tenant => {
                    if(tenant?.uuid === tenantId)
                        return {
                            ...tenant,
                            is_active: tenant?.is_active ? 0 : 1,
                        }
                    
                    return tenant
                }),
            };
        });
    };

    useEffect(() => {
        if(animateError === "animate-shake")
            (async () => {
                await new Promise(resolve => setTimeout(resolve, 500));
                setAnimateError("");
            })();
    }, [animateError]);

    return (
        <div className={`flex items-center justify-center ${animateError}`} >
            <Switch checked={defaultChecked} onCheckedChange={handleChecked} disabled={isDisabled} />
        </div>
    );
};